import React, { useState, useEffect } from "react";
import { TimeLine } from "./components/mytimeline";
import { FiLinkedin, FiMail, FiTwitter } from "react-icons/fi";
import { Cards } from "./components/cards";
import { Skills } from "./components/skills";
import { Footer } from "./components/footer";

function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-slate-950/90 backdrop-blur-xl border-b border-blue-500/20 shadow-lg shadow-blue-500/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="text-2xl font-bold text-white" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              <a href="#about" className="text-slate-200 hover:text-blue-400 transition-colors">About</a>
              <a href="#journey" className="text-slate-200 hover:text-blue-400 transition-colors">Journey</a>
              <a href="#skills" className="text-slate-200 hover:text-blue-400 transition-colors">Skills</a>
              <a href="#projects" className="text-slate-200 hover:text-blue-400 transition-colors">Projects</a>
              <a href="/resume" className="text-slate-200 hover:text-blue-400 transition-colors">Resume</a>
              <a href="#contact" className="text-slate-200 hover:text-blue-400 transition-colors">Contact</a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-slate-200 hover:text-blue-400 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-slate-900/80 backdrop-blur-md border-t border-slate-700/50">
              <div className="px-2 pt-2 pb-3 space-y-1">
                <a href="#about" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>About</a>
                <a href="#journey" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Journey</a>
                <a href="#skills" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Skills</a>
                <a href="#projects" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Projects</a>
                <a href="/resume" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Resume</a>
                <a href="#contact" className="block px-3 py-2 text-slate-200 hover:text-blue-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-blue-500/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
          <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-cyan-500/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse animation-delay-2000"></div>
          <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-indigo-500/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse animation-delay-4000"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`flex flex-col lg:flex-row items-center justify-between transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            {/* Profile Image */}
            <div className="lg:w-1/2 flex justify-center lg:justify-start mb-8 lg:mb-0">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full blur-lg opacity-70 shadow-2xl shadow-blue-500/50"></div>
                <img
                  className="relative w-80 h-80 rounded-full object-cover border-4 border-blue-500/30 shadow-2xl shadow-blue-500/20"
                  src="https://shutterbugss.s3.ap-south-1.amazonaws.com/Akash.png"
                  alt="Akash Perumal"
                />
              </div>
            </div>

            {/* Content */}
            <div className="lg:w-1/2 text-center lg:text-left">
              <div className="space-y-6">
                <div>
                  <h1 className="text-5xl lg:text-7xl font-bold text-slate-100 mb-4" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                    Hi, I'm <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Akash</span>
                  </h1>
                  <h2 className="text-2xl lg:text-3xl text-slate-300 mb-2" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                    The Versatile Developer
                  </h2>
                  <p className="text-lg text-slate-400 max-w-lg" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                    A tech enthusiast who loves to code and an avid photographer. 
                    Join me on my journey of learning and exploring the digital world together.
                  </p>
                </div>

                {/* Social Links */}
                <div className="flex justify-center lg:justify-start space-x-4">
                  <a
                    href="https://in.linkedin.com/in/akash-perumal-954106117"
                    target="_blank"
                    rel="noreferrer"
                    className="p-3 bg-slate-800/60 backdrop-blur-sm rounded-full hover:bg-slate-700/60 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/20"
                  >
                    <FiLinkedin className="w-6 h-6 text-slate-200" />
                  </a>
                  <a
                    href="https://www.twitter.com/codewithsky"
                    target="_blank"
                    rel="noreferrer"
                    className="p-3 bg-slate-800/60 backdrop-blur-sm rounded-full hover:bg-slate-700/60 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/20"
                  >
                    <FiTwitter className="w-6 h-6 text-slate-200" />
                  </a>
                  <a
                    href="mailto:codewithsky.in@gmail.com"
                    className="p-3 bg-slate-800/60 backdrop-blur-sm rounded-full hover:bg-slate-700/60 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/20"
                  >
                    <FiMail className="w-6 h-6 text-slate-200" />
                  </a>
                </div>

                {/* CTA Button */}
                <div className="flex justify-center lg:justify-start">
                  <a
                    href="#projects"
                    className="px-8 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold rounded-full hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 transform hover:scale-105 hover:from-blue-500 hover:to-cyan-500"
                    style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}
                  >
                    View My Work
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-blue-400/60 rounded-full flex justify-center shadow-lg shadow-blue-500/20">
            <div className="w-1 h-3 bg-blue-400/80 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-r from-slate-900/40 to-blue-900/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-100 mb-6" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                About Me
              </h2>
              <div className="space-y-4 text-slate-300 leading-relaxed" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                <p>
                  Hi everyone, I am Akash (Sky😉) - The Versatile Developer. I am a tech enthusiast 
                  who loves to code, and an avid photographer.
                </p>
                <p>
                  Join me on my journey of learning 📚, Let's learn and explore 🌏 together.
                </p>
                <p>
                  I started as a manual tester and have evolved into working with various technologies 
                  including React.js, Python, AWS, Docker, and more.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-r from-slate-800/60 to-blue-800/40 rounded-2xl p-8 backdrop-blur-sm border border-blue-500/20 shadow-xl shadow-blue-500/10">
                <h3 className="text-2xl font-bold text-slate-100 mb-4" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                  What I Do
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                    <span className="text-slate-300" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>Web Development</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                    <span className="text-slate-300" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>Cloud & DevOps</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                    <span className="text-slate-300" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>Automated Testing</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-purple-400 rounded-full"></div>
                    <span className="text-slate-300" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>Photography</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Section */}
      <section id="journey" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-100 mb-4" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              My Journey
            </h2>
            <p className="text-slate-400 text-lg" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              From manual testing to full-stack development
            </p>
          </div>
          <TimeLine />
        </div>
      </section>

      {/* Skills Section */}
      <Skills />

      {/* Projects Section */}
      <section id="projects" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-100 mb-4" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              My Achievements
            </h2>
            <p className="text-slate-400 text-lg" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              Projects and technologies I've worked with
            </p>
          </div>
          <Cards />
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Home;
